// extracted by mini-css-extract-plugin
export default {"authorsGroup":"AbstractSubmission_authorsGroup__WX5gq"};